module.exports = __webpack_public_path__ + "img/focus_health.3a5e1725.svg";